import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import Config from "../../commons/config/Config.js";
import FormValidation from "../../commons/validation/FormValidation.js";
import Validator from "../../commons/validation/Validator.js";
import Loading from "../ui/Loading.js";

import moment from "moment";
import "moment/min/locales";
import Switch from "react-switch";
import Security from "../../commons/security/Security.js";
import AjaxHandler from "../../commons/ajax/AjaxHandler.js";
import AtributoDinamico from "../atributoDinamico/AtributoDinamico.js";
import * as Constants from "../atributoDinamico/constants.js";
import { FormattedMessage, injectIntl } from "react-intl";
import backendStrings from "../../lang/backendStrings.js";
import Select from "react-select";
import 'react-select/dist/react-select.css';
import { DragDropContext } from "react-beautiful-dnd";
import { Droppable } from "react-beautiful-dnd";
import { Draggable } from "react-beautiful-dnd";
import ConfigBusiness from '../../commons/config/ConfigBusiness.js'
import '../../assets/css/styles.css'
import { construirListaVisibleAtributos, reordenarAtributosDinamicos } from './atributosDinamicosVisibles.js'

const ICONS = [
  "fa fa-car",
  "fa fa-truck",
  "fa fa-bus",
  "fa fa-motorcycle",
  "fa fa-user",
  "fa fa-users",
  "fa fa-wrench",
  "fa fa-cog",
  "fa fa-map-marker",
];

// Export nombrado (sin injectIntl) para tests de componente: permite montar la clase
// real con ReactDOM y tomar un ref a la instancia, sin depender del HOC de react-intl.
// Mismo patrón que EricAnalyst.js.
export class TipoFormularioAbm extends Component {
  constructor(props) {
    super(props);
		this.ajaxHandler = new AjaxHandler();

    moment.locale('es');

		this.state = {
			redirectTo: null,
			props: this.props,
			formData: {
				nombre: '',
				icono: '',
        descripcion: '',
				con_medidor: false,
				con_persona: false,
				con_movil: true,
				con_chofer: true,
        con_transportadora: ConfigBusiness.get('checklist.transportadora.actualizarTransportadora') === 'true' ? true : false,
        con_activo_vinculado: false,
				con_ticket: false,
        exclusivoApp: false,
        activo: true,
        atributos_dinamicos: [],
        perfiles: [],
        perfiles_responder: [],
        perfil_notificar_activo: false,
        movil_atributos: [],
        movil_estados_disponibles: [],
        buscar_movil_por: 'dominio',
        persona_estados_disponibles: [],
        ticket_atributos: [{
          id: 'gerenciador',
          nombre: this.props.intl.formatMessage({
            id: "Gerenciador",
            defaultMessage: "Gerenciador",
          }),
          isDisabled: true,
        }],
        ticket_estados: [],
        autogestion: false
      },
      movil_estados: [],
      persona_estados: [
        { id: 1, nombre: 'Activo' },
        { id: 0, nombre: 'Inactivo' },
      ],
      ticket_estados_disponibles: [],
      estados: [
        {
          id: 1,
          nombre: this.props.intl.formatMessage({
            id: "tipoFormularioAbm.state_name_activo",
            defaultMessage: "Activo",
          }),
        },
        {
          id: 0,
          nombre: this.props.intl.formatMessage({
            id: "tipoFormularioAbm.state_name_inactivo",
            defaultMessage: "Inactivo",
          }),
        },
      ],
      buscarMovilPorOptions: [
        {
          value: 'dominio',
          label: this.props.intl.formatMessage({
            id: 'tipoFormularioAbm.render.general_data.buscar_movil_por_dominio',
            defaultMessage: 'Dominio',
          }),
        },
        {
          value: 'unidad',
          label: this.props.intl.formatMessage({
            id: 'tipoFormularioAbm.render.general_data.buscar_movil_por_unidad',
            defaultMessage: 'Unidad',
          }),
        },
      ],
      movil_atributos: [
        {
          id: 'marca',
          nombre: this.props.intl.formatMessage({
            id: "tipoFormularioAbm.select_movil_atributos.marca",
            defaultMessage: "Marca",
          }),
        },
        {
          id: 'modelo',
          nombre: this.props.intl.formatMessage({
            id: "tipoFormularioAbm.select_movil_atributos.modelo",
            defaultMessage: "Modelo",
          }),
        },
        {
          id: 'chasis_nro',
          nombre: this.props.intl.formatMessage({
            id: "tipoFormularioAbm.select_movil_atributos.chasis_nro",
            defaultMessage: "Chasis",
          }),
        },
        {
          id: 'motor_nro',
          nombre: this.props.intl.formatMessage({
            id: "tipoFormularioAbm.select_movil_atributos.motor_nro",
            defaultMessage: "Motor",
          }),
        },
        {
          id: 'color',
          nombre: this.props.intl.formatMessage({
            id: "tipoFormularioAbm.select_movil_atributos.color",
            defaultMessage: "Color",
          }),
        },
        {
          id: 'centro_costos',
          nombre: this.props.intl.formatMessage({
            id: "tipoFormularioAbm.select_movil_atributos.centro_costos",
            defaultMessage: "Centro de Costos",
          }),
        },
        {
          id: 'plan_preventivo',
          nombre: this.props.intl.formatMessage({
            id: "tipoFormularioAbm.select_movil_atributos.plan_preventivo",
            defaultMessage: "Plan Preventivo",
          }),
        },
        {
          id: 'combustible',
          nombre: this.props.intl.formatMessage({
            id: "tipoFormularioAbm.select_movil_atributos.combustible",
            defaultMessage: "Combustible",
          }),
        },
        {
          id: 'proveedor_gps',
          nombre: this.props.intl.formatMessage({
            id: "tipoFormularioAbm.select_movil_atributos.proveedor_gps",
            defaultMessage: "Proveedor GPS",
          }),
        },
        {
          id: 'compania_origen',
          nombre: this.props.intl.formatMessage({
            id: "tipoFormularioAbm.select_movil_atributos.compania_origen",
            defaultMessage: "Compañia de Origen",
          }),
        },
        {
          id: 'titular',
          nombre: this.props.intl.formatMessage({
            id: "tipoFormularioAbm.select_movil_atributos.titular",
            defaultMessage: "Titular",
          }),
        },
        {
          id: 'telepeaje',
          nombre: this.props.intl.formatMessage({
            id: "tipoFormularioAbm.select_movil_atributos.telepeaje",
            defaultMessage: "Peaje",
          }),
        },
        {
          id: 'anio',
          nombre: this.props.intl.formatMessage({
            id: "tipoFormularioAbm.select_movil_atributos.anio",
            defaultMessage: "Año",
          }),
        },
        {
          id: 'estado',
          nombre: this.props.intl.formatMessage({
            id: "tipoFormularioAbm.select_movil_atributos.estado",
            defaultMessage: "Estado",
          }),
        },
      ],
      ticket_atributos: [
        {
          id: 'servicio',
          nombre: this.props.intl.formatMessage({
            id: "Servicio",
            defaultMessage: "Servicio",
          }),
        },
        {
          id: 'gerenciador',
          nombre: this.props.intl.formatMessage({
            id: "Gerenciador",
            defaultMessage: "Gerenciador",
          }),
        },
        {
          id: 'centro_costos',
          nombre: this.props.intl.formatMessage({
            id: "Centro_de_costos",
            defaultMessage: "Centro de costos",
          }),
        },
        {
          id: 'mano_de_obra',
          nombre: this.props.intl.formatMessage({
            id: "Presupuesto_mano_de_obra",
            defaultMessage: "Presupuesto mano de obra",
          }),
        },
        {
          id: 'repuestos',
          nombre: this.props.intl.formatMessage({
            id: "Presupuesto_de_repuestos",
            defaultMessage: "Presupuesto de repuestos",
          }),
        },
        {
          id: 'factura',
          nombre: this.props.intl.formatMessage({
            id: "Factura",
            defaultMessage: "Factura",
          }),
        },
      ],
      errors: [],
      perfilesSelect: [],
      loading: false,
      mostrarInactivos: ConfigBusiness.get('checklist.atributosDinamicos.mostrarInactivos') === 'true' ? true : false,
      mostrarVideoEric: false,
      ericConfig: {
        cargando: false,
        guardando: false,
        configurada: false,
        personaIdInspektlabs: null,
        activo: false,
        video360: false,
        ocrOdometro: false,
        ocrVin: false,
        ocrPatente: false,
        brandCompliance: false,
        photo360: false,
        capacidades_orden: [],
      },
      ericCapacidadesTenant: {
        video360: false,
        ocr_odometro: false,
        ocr_vin: false,
        ocr_patente: false,
        brand_compliance: false,
        photo_360: false,
      },
      ericMensaje: null,
      ericHovered: false,
      ericAnimating: null,
    };

    this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
    this.handleChangeAtributoDinamico = this.handleChangeAtributoDinamico.bind(this);
    this.handleAddAtributoDinamico = this.handleAddAtributoDinamico.bind(this);
    this.handleDeleteAtributoDinamico = this.handleDeleteAtributoDinamico.bind(this);
    this.handleInputFormChange = this.handleInputFormChange.bind(this);
		this.handleIconChange = this.handleIconChange.bind(this)
		this.handleConMedidorChange = this.handleConMedidorChange.bind(this)
		this.handlePerfilChange = this.handlePerfilChange.bind(this)
    this.handlePerfilResponderChange = this.handlePerfilResponderChange.bind(this);
    this.handleAtributo = this.handleAtributo.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onDragEnd = this.onDragEnd.bind(this);
    this.initEricConfig = this.initEricConfig.bind(this);
    this.handleEricToggle = this.handleEricToggle.bind(this);
    this.handleGuardarEricConfig = this.handleGuardarEricConfig.bind(this);

    this.formValidation = new FormValidation({
      component: this,
      validators: {
        "formData.nombre": (value) => Validator.notEmpty(value),
        "formData.icono": (value) => Validator.notEmpty(value),
      },
    });
  }

  onDragEnd(result) {
    if (!result.destination) return;

    if (result.destination.droppableId === 'eric-capacidades') {
      var orden = this.state.ericConfig.capacidades_orden.slice();
      var item = orden[result.source.index];
      orden.splice(result.source.index, 1);
      orden.splice(result.destination.index, 0, item);
      this.setState(function(prev) {
        return { ericConfig: Object.assign({}, prev.ericConfig, { capacidades_orden: orden }), ericMensaje: null };
      });
      return;
    }

    if (result.destination.droppableId !== "1") return;
    let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
    // VEC-3916/VEC-3917: la traducción de la lista visible (dibujada,
    // sin el marcador de Eric cuando está escondido) a la lista completa vive en
    // `reordenarAtributosDinamicos`, que reusa la misma regla de visibilidad que
    // `construirListaVisibleAtributos` — antes este método tenía su propia copia
    // de esa regla (`a.tipoValor !== Constants.ID_ERIC_IA`) y reinsertaba a Eric
    // por un índice numérico que no sobrevive a un drag que lo cruza.
    formDataCopy.atributos_dinamicos = reordenarAtributosDinamicos(
      formDataCopy.atributos_dinamicos,
      this.state.ericConfig.activo,
      result.source.index,
      result.destination.index
    );
    this.sincronizarProveedorComun(formDataCopy.atributos_dinamicos);
    this.setState({ formData: formDataCopy });
  }
  initForm() {
    this.setState({ loading: true });
    let component = this;
    let perfilesSelect = [];
    let movil_estados = [];
    let ticketEstadosDisponibles = [];
    Promise.all([
      this.state.props.action !== "ADD"
        ? this.ajaxHandler.getJson("/tipoformulario/" + this.state.props.match.params.id)
        : null,
      this.ajaxHandler.getJson("/perfiles"),
      ConfigBusiness.get('moviles.estados'),
      this.ajaxHandler.getJson('/tickets/estados').catch(() => [])
    ])
      .then((data) => {
        let formDataNew = data[0];
        perfilesSelect = data[1];
        movil_estados = data[2] ? data[2].split(',').map(e =>({id: e, nombre: e})) : [];
        ticketEstadosDisponibles = data[3] ? data[3].map(e => ({ id: e, nombre: e })) : [];
        if (formDataNew) {
          formDataNew.atributos_dinamicos = formDataNew.atributos_dinamicos.map((atributo) => {
            atributo.value = atributo.valorDefault;
            return atributo;
          });
          this.sincronizarProveedorComun(formDataNew.atributos_dinamicos);
          if(formDataNew.movil_atributos_json){
            let movil_atributos = [];
            let movil_atributos_array = JSON.parse(formDataNew.movil_atributos_json);
            this.state.movil_atributos.forEach(function(element) {
              if(movil_atributos_array.includes(element.id))
                movil_atributos.push(element);
            })
            formDataNew.movil_atributos = movil_atributos;
          }
          if(formDataNew.movil_estados_disponibles_json){
            let movil_estados_disponibles = [];
            let movil_estados_disponibles_array = JSON.parse(formDataNew.movil_estados_disponibles_json);
            movil_estados.forEach(function(element) {
              if(movil_estados_disponibles_array.includes(element.id))
                movil_estados_disponibles.push(element);
            })
            formDataNew.movil_estados_disponibles = movil_estados_disponibles;
          }
          if(formDataNew.persona_estados_disponibles_json){
            let persona_estados_disponibles = [];
            let arr = JSON.parse(formDataNew.persona_estados_disponibles_json);
            component.state.persona_estados.forEach(function(element) {
              if(arr.includes(element.id)) persona_estados_disponibles.push(element);
            });
            formDataNew.persona_estados_disponibles = persona_estados_disponibles;
          }
          if(formDataNew.ticket_atributos_json){
            let ticket_atributos = [];
            let ticket_atributos_array = JSON.parse(formDataNew.ticket_atributos_json);
            this.state.ticket_atributos.forEach(function(element) {
              if(ticket_atributos_array.includes(element.id))
                ticket_atributos.push(element);
            })
            formDataNew.ticket_atributos = ticket_atributos;
          }
          if (formDataNew.ticket_estados_json) {
            let ticket_estados = [];
            let ticket_estados_array = JSON.parse(formDataNew.ticket_estados_json);
            ticketEstadosDisponibles.forEach(function(element) {
              if (ticket_estados_array.includes(element.id))
                ticket_estados.push(element);
            });
            formDataNew.ticket_estados = ticket_estados;
          }
          // VEC-4246: el marcador de Eric ya no se agrega al abrir el formulario. Si
          // se agregaba acá, el primer guardado lo creaba activo aunque el usuario no
          // hubiera prendido Eric (o no tuviera permiso para hacerlo) y quedaba un
          // marcador sin config. Ahora lo agregan `initEricConfig` (config ya activa)
          // y `handleEricToggle` (el usuario prende el switch).
          component.setState({ formData: formDataNew });
          if (ConfigBusiness.get('eric.inspecciones.general.activo') === 'true') {
            component.initEricConfig(formDataNew.id);
          }
        } else {
          this.handleAddAtributoDinamico();
          if (ConfigBusiness.get('eric.inspecciones.general.activo') === 'true') {
            component.setState({
              ericCapacidadesTenant: {
                video360:         ConfigBusiness.get('eric.inspecciones.capacidades.video_360') === 'true',
                ocr_odometro:     ConfigBusiness.get('eric.inspecciones.capacidades.ocr_odometro') === 'true',
                ocr_vin:          ConfigBusiness.get('eric.inspecciones.capacidades.ocr_vin') === 'true',
                ocr_patente:      ConfigBusiness.get('eric.inspecciones.capacidades.ocr_patente') === 'true',
                brand_compliance: ConfigBusiness.get('eric.inspecciones.capacidades.brand_compliance') === 'true',
                photo_360:        ConfigBusiness.get('eric.inspecciones.capacidades.photo_360') === 'true',
              },
            });
          }
        }
      })
      .catch(function (error) {
        console.log(error);
        component.exit();
      })
      .finally(() => {
        this.setState({
          loading: false,
          perfilesSelect: perfilesSelect,
          movil_estados: movil_estados,
          ticket_estados_disponibles: ticketEstadosDisponibles
        });
      });
  }
  componentWillMount() {
    if(ConfigBusiness.get('moviles.trabajaConDivisiones.habilitado') === 'true'){
      this.state.ticket_atributos.push({
        id: 'division',
        nombre: this.props.intl.formatMessage({
          id: "formularios.tipoFormularioAbm.division",
          defaultMessage: "División",
        }),
      });
    }
    if(ConfigBusiness.get('moviles.cebe.habilitado') === 'true'){
      this.state.ticket_atributos.push({
        id: 'cebe',
        nombre: this.props.intl.formatMessage({
          id: "Centro_de_beneficios",
          defaultMessage: "Centro de beneficios",
        }),
      });
    }
    this.setState({
      ticket_atributos: this.state.ticket_atributos
    });
    if ((Security.hasPermission('CHECKLIST_CREAR_TIPO_FORMULARIOS') && this.state.props.action === 'ADD') ||
    (Security.hasPermission('CHECKLIST_EDITAR_TIPO_FORMULARIOS') && this.state.props.action === 'EDIT') ||
    (Security.hasPermission('CHECKLIST_VISUALIZAR_TIPO_FORMULARIOS') && this.state.props.action === 'VIEW')) {
        this.ajaxHandler.subscribe(this);
        this.initForm();
    } else {
        this.setState({
            redirectTo: '/error'
        });
    }
  }

  componentWillUnmount() {
    this.ajaxHandler.unsubscribe();
    if (this._ericAnimTimer) clearTimeout(this._ericAnimTimer);
  }

  handleCheckboxChange(name, activo) {
    this.state.formData[name] = activo;
    if (name === "con_persona" && activo) this.state.formData["con_chofer"] = !activo;
    this.setState({
      formData: this.state.formData,
    });
  }

	handleConMedidorChange(activo) {
		let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));

		formDataCopy["con_medidor"] = activo;
		let atributoMedidorIndex = formDataCopy.atributos_dinamicos.findIndex(atributo => atributo.tipoValor == Constants.ID_MEDIDOR)
		if (atributoMedidorIndex == -1) {
			if (activo) {
				let templateAtributoCopy = JSON.parse(JSON.stringify(Constants.TEMPLATE_ATRIBUTO_MEDIDOR));
				templateAtributoCopy._localKey = this.generateLocalAtributoKey();
				formDataCopy.atributos_dinamicos.push(templateAtributoCopy);
			}
		}

		else {
			if (formDataCopy.atributos_dinamicos[atributoMedidorIndex].id )
					formDataCopy.atributos_dinamicos[atributoMedidorIndex].activo = activo
			else
					formDataCopy.atributos_dinamicos.splice(atributoMedidorIndex, 1)
		}
		this.setState({
			formData: formDataCopy
		});
	}


	handleInputFormChange(event) {
		const target = event.target;
		const name = target.name;
		const value = target.type === 'checkbox' ? target.checked : target.value;

		this.state.formData[name] = value;
		this.setState({
			formData: this.state.formData
		});
  }

  handleInputFormChange(event) {
    const target = event.target;
    const name = target.name;
    const value = target.type === "checkbox" ? target.checked : target.value;

    this.state.formData[name] = value;
    this.setState({
      formData: this.state.formData,
    });
  }

  // VEC-3704: identidad estable por atributo (id del backend, o clave local para uno
  // recién agregado sin guardar), independiente de su posición en la lista. Usada como
  // key/dragId para que React no reutilice la tarjeta equivocada al reordenar.
  generateLocalAtributoKey() {
    this._localAtributoKeySeq = (this._localAtributoKeySeq || 0) + 1;
    return "atributo-local-" + this._localAtributoKeySeq;
  }

  getAtributoDragKey(atributo) {
    if (atributo.id !== undefined && atributo.id !== null) return "atributo-" + atributo.id;
    if (!atributo._localKey) atributo._localKey = this.generateLocalAtributoKey();
    return atributo._localKey;
  }

  handleAddAtributoDinamico() {
    let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
    let templateAtributoCopy = JSON.parse(JSON.stringify(Constants.TEMPLATE_ATRIBUTO));
    templateAtributoCopy._localKey = this.generateLocalAtributoKey();
    formDataCopy.atributos_dinamicos.push(templateAtributoCopy);
    this.setState({
      formData: formDataCopy,
    });
  }

  // VEC-3955: con proveedores por servicio, todas las preguntas que generan ticket correctivo comparten el
  // proveedor (el checklist genera un único ticket). Lo define la primera de ellas, en el orden del formulario.
  esPreguntaCorrectiva(atributo) {
    return !!atributo.genera_ticket && atributo.activo !== false && atributo.activo !== 0 && atributo.activo !== '0';
  }

  // Deja el mismo proveedor en todas las preguntas que generan ticket: el elegido explícitamente, o si no
  // (alta, baja, reorden, cambio de "Genera ticket"), el primero que ya tenga alguna de ellas.
  sincronizarProveedorComun(atributos, proveedorElegido) {
    if (ConfigBusiness.get('servicios.proveedores.habilitado') !== 'true') return;
    const correctivas = atributos.filter(this.esPreguntaCorrectiva);
    const conProveedor = correctivas.find((a) => a.gerenciador_id);
    const comun = proveedorElegido !== undefined ? proveedorElegido : (conProveedor ? conProveedor.gerenciador_id : null);
    correctivas.forEach((a) => { a.gerenciador_id = comun; });
  }

  getProveedorComunInfo() {
    if (ConfigBusiness.get('servicios.proveedores.habilitado') !== 'true') return null;
    const correctivas = this.state.formData.atributos_dinamicos.filter(this.esPreguntaCorrectiva);
    if (!correctivas.length) return null;
    return {
      definidaPor: correctivas[0],
      proveedorId: correctivas[0].gerenciador_id || null,
      servicios: correctivas.map((a) => a.servicio_id).filter(Boolean),
    };
  }

  handleDeleteAtributoDinamico(index) {
    let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
    formDataCopy.atributos_dinamicos.splice(index, 1);
    this.sincronizarProveedorComun(formDataCopy.atributos_dinamicos);
    this.setState({
      formData: formDataCopy,
    });
  }

  handleChangeAtributoDinamico(index, key, value) {
    let atributoDinamico = this.state.formData.atributos_dinamicos[index];
    atributoDinamico[key] = value;
    if (key == "value") atributoDinamico.valorDefault = value;
    if (key === "gerenciador_id" && this.esPreguntaCorrectiva(atributoDinamico)) {
      this.sincronizarProveedorComun(this.state.formData.atributos_dinamicos, value);
    } else if (key === "genera_ticket" || key === "genera_ticket_gestoria" || key === "activo") {
      this.sincronizarProveedorComun(this.state.formData.atributos_dinamicos);
    }
    this.setState({
      formData: this.state.formData,
    });
  }

  handleIconChange(e, icono) {
    e.preventDefault();
    let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
    formDataCopy["icono"] = icono;
    this.setState({
      formData: formDataCopy,
    });
  }

  handlePerfilChange(perfiles) {
    let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
    formDataCopy["perfiles"] = perfiles;
    this.setState({
      formData: formDataCopy,
    });
  }

  handlePerfilResponderChange(perfiles) {
    let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
    formDataCopy["perfiles_responder"] = perfiles;
    this.setState({
      formData: formDataCopy,
    });
  }
  
  handleAtributo(atributos, name) {
    let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
    if (name === 'ticket_atributos' && formDataCopy.con_ticket) {
      const gerenciador = this.state.ticket_atributos.find(a => a.id === 'gerenciador');
      if (!atributos.some(a => a.id === 'gerenciador')) {
        atributos = [gerenciador, ...atributos];
      }
    }
    formDataCopy[name] = atributos;
    this.setState({ formData: formDataCopy });

  }

  handleSubmit(event) {
    this.setState({ loading: true });
    let component = this;
    this.state.formData.perfiles_ids = this.state.formData.perfiles.map((perfil) => perfil.id);
    this.state.formData.perfiles_responder_ids = this.state.formData.perfiles_responder.map((perfil) => perfil.id);
    this.state.formData.movil_atributos_json = this.state.formData.movil_atributos ? JSON.stringify(this.state.formData.movil_atributos.map((atributo) => atributo.id)) : null;
    this.state.formData.ticket_atributos_json = this.state.formData.ticket_atributos ? JSON.stringify(this.state.formData.ticket_atributos.map((atributo) => atributo.id)) : null;
    this.state.formData.ticket_estados_json = this.state.formData.ticket_estados && this.state.formData.ticket_estados.length
      ? JSON.stringify(this.state.formData.ticket_estados.map((estado) => estado.id))
      : null;
    this.state.formData.movil_estados_disponibles_json = this.state.formData.movil_estados_disponibles && this.state.formData.movil_estados_disponibles.length ? JSON.stringify(this.state.formData.movil_estados_disponibles.map((estado) => estado.id)) : null;
    this.state.formData.persona_estados_disponibles_json = this.state.formData.persona_estados_disponibles && this.state.formData.persona_estados_disponibles.length
      ? JSON.stringify(this.state.formData.persona_estados_disponibles.map((estado) => estado.id))
      : null;
    this.state.formData.atributos_dinamicos.map((atributo, index) => {
      atributo.order = index;
    });
    // VEC-3916/VEC-3917: un atributo que nunca monta su tarjeta en esta
    // sesión (inactivo, con `mostrarInactivos` apagado) nunca pasa por
    // `AtributoDinamico.componentDidMount`, que es donde `tareas` se transforma del
    // formato crudo del GET (`{id, nombre, pivot}`) al formato que espera el POST/PUT
    // (`{value, label}`). Sin esta normalización, `TipoFormularioController` lee
    // `$tarea['value']` (undefined en el formato crudo), hace `sync([null])` y
    // desvincula las tareas reales del atributo. Se aplica a todos los atributos
    // (no solo a los escondidos) porque es idempotente: uno ya transformado tiene
    // `value`/`label`, no `id`, y cae directo al else.
    this.state.formData.atributos_dinamicos.forEach((atributo) => {
      if (!Array.isArray(atributo.tareas)) return;
      atributo.tareas = atributo.tareas.map((tarea) =>
        tarea && tarea.id !== undefined && tarea.id !== null
          ? { value: tarea.id, label: tarea.nombre }
          : tarea
      );
    });
    if (ConfigBusiness.get('eric.inspecciones.general.activo') === 'true' && this.props.action !== 'ADD' && this.state.ericConfig.configurada) {
      this.handleGuardarEricConfig();
    }
    // VEC-4246: un marcador de Eric sin id es uno nuevo; si Eric no quedó prendido,
    // no se manda, para no crear un marcador sin config activa.
    const ericActivo = this.state.ericConfig.activo;
    const atributosAEnviar = this.state.formData.atributos_dinamicos.filter((atributo) =>
      ericActivo || atributo.tipoValor !== Constants.ID_ERIC_IA || atributo.id
    );
    this.ajaxHandler
      .fetch("/tipoformulario" + (this.props.action === "ADD" ? "" : "/" + this.state.formData.id), {
        method: this.props.action === "ADD" ? "POST" : "PUT",
        body: JSON.stringify({
          ...this.state.formData,
          atributos_dinamicos: atributosAEnviar,
        }),
      })
      .then((response) => {
        if (response.status !== 400) {
          if (this.props.action === 'ADD' && ConfigBusiness.get('eric.inspecciones.general.activo') === 'true' && this.state.ericConfig.activo) {
            response.json().then((data) => {
              if (data && data.id) {
                this.handleGuardarEricConfig(data.id);
              }
              component.exit();
            });
          } else {
            component.exit();
          }
        } else {
          response.json().then((data) => {
            this.setState({
              errors: data.detalle,
            });
          });
        }
        window.scrollTo(0, 0);
      })
      .catch((error) => {
        component.ajaxHandler.handleError(error);
      })
      .finally(() => {
        this.setState({ loading: false });
      });
    event.preventDefault();
  }

  initEricConfig(tipoFormularioId) {
    var component = this;
    this.setState(function(prev) {
      return { ericConfig: Object.assign({}, prev.ericConfig, { cargando: true }) };
    });
    fetch(Config.get('apiUrlBase') + '/v1/form-types/' + tipoFormularioId + '/inspection-config', {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization-Token': localStorage.getItem('token'),
      },
    })
    .then(function(response) {
      if (response.status === 404) {
        component.setState({
          ericConfig: {
            cargando: false,
            guardando: false,
            configurada: true,
            personaIdInspektlabs: null,
            activo: false,
            video360: false,
            ocrOdometro: false,
            ocrVin: false,
            ocrPatente: false,
            capacidades_orden: [],
          },
        });
        return;
      }
      if (!response.ok) {
        component.setState(function(prev) {
          return { ericConfig: Object.assign({}, prev.ericConfig, { cargando: false }) };
        });
        return;
      }
      return response.json().then(function(data) {
        var cap = data.capacidades_tenant || {};
        var defaultOrden = [];
        if (cap.video360) defaultOrden.push('video_360');
        if (cap.ocr_odometro) defaultOrden.push('ocr_odometro');
        if (cap.ocr_vin) defaultOrden.push('ocr_vin');
        if (cap.ocr_patente) defaultOrden.push('ocr_patente');
        var orden = (data.capacidades_orden && data.capacidades_orden.length > 0)
          ? data.capacidades_orden
          : defaultOrden;
        component.setState({
          ericConfig: {
            cargando: false,
            guardando: false,
            configurada: true,
            personaIdInspektlabs: data.persona_id_inspektlabs,
            activo: data.activo || false,
            video360: data.video_360 || false,
            ocrOdometro: data.ocr_odometro || false,
            ocrVin: data.ocr_vin || false,
            ocrPatente: data.ocr_patente || false,
            brandCompliance: data.brand_compliance || false,
            photo360: data.photo_360 || false,
            capacidades_orden: orden,
          },
          ericCapacidadesTenant: {
            video360: cap.video360 || false,
            ocr_odometro: cap.ocr_odometro || false,
            ocr_vin: cap.ocr_vin || false,
            ocr_patente: cap.ocr_patente || false,
            brand_compliance: cap.brand_compliance || false,
            photo_360: cap.photo_360 || false,
          },
        });
        // VEC-4246: formularios con Eric activo guardados antes de que existiera el
        // marcador. Se agrega solo con la config activa confirmada por el backend.
        if (data.activo) {
          component.setState(function(prev) {
            var atributos = prev.formData.atributos_dinamicos || [];
            var tieneEric = atributos.some(function(a) { return a.eric_capacidad === 'eric_ia' || a.tipoValor === Constants.ID_ERIC_IA; });
            if (tieneEric) return null;
            var ericMarcador = JSON.parse(JSON.stringify(Constants.TEMPLATE_ATRIBUTO));
            ericMarcador.nombre = 'Eric IA — Inspection & OCR';
            ericMarcador.tipoValor = Constants.ID_ERIC_IA;
            ericMarcador.eric_capacidad = 'eric_ia';
            return { formData: Object.assign({}, prev.formData, { atributos_dinamicos: atributos.concat([ericMarcador]) }) };
          });
        }
      });
    })
    .catch(function() {
      component.setState(function(prev) {
        return { ericConfig: Object.assign({}, prev.ericConfig, { cargando: false }) };
      });
    });
  }

  handleEricToggle(campo, valor) {
    var self = this;
    var config = Object.assign({}, this.state.ericConfig);
    config[campo] = valor;
    if (campo === 'video360' && valor) config.ocrPatente = false;
    if (campo === 'ocrPatente' && valor) config.video360 = false;
    if (campo === 'brandCompliance' && valor) {
      config.video360 = false;
      config.ocrOdometro = false;
      config.ocrVin = false;
      config.ocrPatente = false;
      config.photo360 = false;
    }
    if (campo === 'photo360' && valor) {
      config.video360 = false;
      config.ocrOdometro = false;
      config.ocrVin = false;
      config.ocrPatente = false;
      config.brandCompliance = false;
    }
    if (campo !== 'brandCompliance' && valor) config.brandCompliance = false;
    if (campo !== 'photo360' && valor) config.photo360 = false;

    if (campo === 'activo' && !valor) {
      if (this._ericAnimTimer) clearTimeout(this._ericAnimTimer);
      this.setState({ ericAnimating: 'off-exiting' });
      this._ericAnimTimer = setTimeout(function() {
        var formDataCopy = JSON.parse(JSON.stringify(self.state.formData));
        var ericIdx = formDataCopy.atributos_dinamicos.findIndex(function(a) { return a.tipoValor === Constants.ID_ERIC_IA; });
        if (ericIdx > 0) {
          var ericItem = formDataCopy.atributos_dinamicos.splice(ericIdx, 1)[0];
          formDataCopy.atributos_dinamicos.unshift(ericItem);
        }
        self.setState({ ericConfig: config, formData: formDataCopy, ericAnimating: 'off-entering' });
        self._ericAnimTimer = setTimeout(function() {
          self.setState({ ericAnimating: null });
        }, 380);
      }, 320);
      return;
    }

    if (campo === 'activo' && valor) {
      if (this._ericAnimTimer) clearTimeout(this._ericAnimTimer);
      this.setState({ ericAnimating: 'on-exiting' });
      this._ericAnimTimer = setTimeout(function() {
        var formDataCopy = JSON.parse(JSON.stringify(self.state.formData));
        if (!formDataCopy.atributos_dinamicos) formDataCopy.atributos_dinamicos = [];
        var ericIdx = formDataCopy.atributos_dinamicos.findIndex(function(a) {
          return a.tipoValor === Constants.ID_ERIC_IA;
        });
        if (ericIdx >= 0) {
          // Was toggled off (moved to front) — move back to bottom
          var ericItem = formDataCopy.atributos_dinamicos.splice(ericIdx, 1)[0];
          // VEC-3916: el marcador puede haber quedado con activo=0 (por
          // ejemplo, un arreglo por base que lo desactivó sin tocar la config). Si
          // no se corrige acá, la tarjeta de Eric queda escondida por el filtro
          // `(atributoDinamico.activo || mostrarInactivos)` de la lista, sin forma
          // de volver a apagar el switch desde la pantalla.
          ericItem.activo = true;
          formDataCopy.atributos_dinamicos.push(ericItem);
        } else {
          var ericMarcador = JSON.parse(JSON.stringify(Constants.TEMPLATE_ATRIBUTO));
          ericMarcador.nombre = 'Eric IA — Inspection & OCR';
          ericMarcador.tipoValor = Constants.ID_ERIC_IA;
          ericMarcador.eric_capacidad = 'eric_ia';
          formDataCopy.atributos_dinamicos.push(ericMarcador);
        }
        self.setState({ ericConfig: config, formData: formDataCopy, ericAnimating: 'on-entering' }, function() {
          if (self._ericCardRef) {
            self._ericCardRef.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        });
        self._ericAnimTimer = setTimeout(function() {
          self.setState({ ericAnimating: null });
        }, 380);
      }, 300);
      return;
    }

    this.setState({ ericConfig: config, ericMensaje: null });
  }

  handleGuardarEricConfig(overrideId) {
    var config = this.state.ericConfig;
    var tipoFormularioId = overrideId || this.state.formData.id;
    fetch(Config.get('apiUrlBase') + '/v1/form-types/' + tipoFormularioId + '/inspection-config', {
      method: 'PUT',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization-Token': localStorage.getItem('token'),
      },
      body: JSON.stringify({
        persona_id_inspektlabs: config.personaIdInspektlabs,
        activo: config.activo ? 1 : 0,
        video_360: config.video360 ? 1 : 0,
        ocr_odometro: config.ocrOdometro ? 1 : 0,
        ocr_vin: config.ocrVin ? 1 : 0,
        ocr_patente: config.ocrPatente ? 1 : 0,
        brand_compliance: config.brandCompliance ? 1 : 0,
        photo_360: config.photo360 ? 1 : 0,
        capacidades_orden: config.capacidades_orden,
      }),
    });
  }

  handleCancel(event) {
    this.exit();
  }

  exit() {
    this.setState({
      redirectTo: "/tipoformulario",
    });
  }

  atributoDinamicoServicosRequeridosFaltantes() {
    const esItemsMode = ConfigBusiness.get('tickets.presupuesto.tipo') === 'detallado'
      && (ConfigBusiness.get('tickets.trabajaConManoDeObra.habilitado') === 'true'
        || ConfigBusiness.get('tickets.trabajaConRepuestos.habilitado') === 'true');
    return (this.state.formData.atributos_dinamicos.filter(
      function(attribute){
        if(attribute.genera_ticket_gestoria)
          return !attribute.servicio_gestoria_id;
        if(attribute.genera_ticket)
          return !esItemsMode && attribute.tareas.length === 0
      }
    )).length
  }

  atributoDinamicoFormularioAsociadoFaltante() {
    return (this.state.formData.atributos_dinamicos.filter(
      function(atributo) {
        return atributo.activo && atributo.tipoValor === Constants.ID_FORMULARIO_ASOCIADO && !atributo.tipo_formulario_asociado_id;
      }
    )).length
  }

  renderEricIACardInner() {
    var ericHabilitado = ConfigBusiness.get('eric.inspecciones.general.activo') === 'true';
    return (
      <React.Fragment>
        <h4 className="form-section">
          <i className="fa fa-magic"></i>
          {' '}Eric IA — Inspection &amp; OCR
          {ConfigBusiness.get('eric.inspecciones.general.embedUrl') && (
            <button
              type="button"
              className="btn btn-sm btn-link ml-1"
              onClick={() => this.setState({ mostrarVideoEric: true })}
              title={this.props.intl.formatMessage({ id: 'tipoFormularioAbm.eric.ver_video', defaultMessage: 'Ver video explicativo' })}
              style={{ verticalAlign: 'middle', padding: '0 6px', fontSize: '18px' }}
            >
              <i className="fa fa-info-circle text-info"></i>
            </button>
          )}
          {!ericHabilitado && (
            <span className="badge badge-secondary ml-2" style={{ fontSize: '11px', verticalAlign: 'middle' }}>
              <FormattedMessage id="tipoFormularioAbm.eric.badge_no_disponible" defaultMessage="No disponible" />
            </span>
          )}
        </h4>
        <div style={!ericHabilitado ? { opacity: 0.45, pointerEvents: 'none' } : {}}>
          {!ericHabilitado && (
            <div className="row"><div className="col-md-12">
              <div className="alert alert-secondary mb-2">
                <i className="fa fa-lock mr-1"></i>
                <FormattedMessage id="tipoFormularioAbm.eric.vitrina_no_habilitado" defaultMessage="La integración Eric IA no está habilitada. Contactá a soporte para activarla." />
              </div>
            </div></div>
          )}
          {ericHabilitado && this.state.ericConfig.cargando && (
            <div className="text-center p-2"><Loading /></div>
          )}
          {ericHabilitado && !this.state.ericConfig.cargando && (
            <div>
              <div className="d-flex align-items-center flex-wrap mb-2" style={{ gap: '24px' }}>
                <div className="d-flex align-items-center">
                  <label className="label-control mb-0 mr-2">
                    <FormattedMessage id="tipoFormularioAbm.eric.habilitado_label" defaultMessage="Habilitado para este formulario:" />
                  </label>
                  <Switch
                    onChange={valor => this.handleEricToggle('activo', valor)}
                    checked={this.state.ericConfig.activo}
                    disabled={this.state.props.action === 'VIEW' || !Security.hasPermission('ERIC_INSPECTOR_CONFIGURAR')}
                    offColor="#FF4961"
                    onColor="#28D094"
                  />
                </div>
                {this.state.ericConfig.activo && this.state.ericCapacidadesTenant.video360 && (
                  <div className="d-flex align-items-center">
                    <label className="label-control mb-0 mr-2"><FormattedMessage id="tipoFormularioAbm.eric.video360_label" defaultMessage="Video 360°" />:</label>
                    <Switch onChange={valor => this.handleEricToggle('video360', valor)} checked={this.state.ericConfig.video360} disabled={this.state.props.action === 'VIEW' || !Security.hasPermission('ERIC_INSPECTOR_CONFIGURAR') || this.state.ericConfig.ocrPatente || this.state.ericConfig.brandCompliance || this.state.ericConfig.photo360} offColor="#FF4961" onColor="#28D094" />
                  </div>
                )}
                {this.state.ericConfig.activo && this.state.ericCapacidadesTenant.ocr_odometro && (
                  <div className="d-flex align-items-center">
                    <label className="label-control mb-0 mr-2"><FormattedMessage id="tipoFormularioAbm.eric.ocr_odometro_label" defaultMessage="OCR Odómetro" />:</label>
                    <Switch onChange={valor => this.handleEricToggle('ocrOdometro', valor)} checked={this.state.ericConfig.ocrOdometro} disabled={this.state.props.action === 'VIEW' || !Security.hasPermission('ERIC_INSPECTOR_CONFIGURAR') || this.state.ericConfig.brandCompliance || this.state.ericConfig.photo360} offColor="#FF4961" onColor="#28D094" />
                  </div>
                )}
                {this.state.ericConfig.activo && this.state.ericCapacidadesTenant.ocr_vin && (
                  <div className="d-flex align-items-center">
                    <label className="label-control mb-0 mr-2"><FormattedMessage id="tipoFormularioAbm.eric.ocr_vin_label" defaultMessage="OCR VIN" />:</label>
                    <Switch onChange={valor => this.handleEricToggle('ocrVin', valor)} checked={this.state.ericConfig.ocrVin} disabled={this.state.props.action === 'VIEW' || !Security.hasPermission('ERIC_INSPECTOR_CONFIGURAR') || this.state.ericConfig.brandCompliance || this.state.ericConfig.photo360} offColor="#FF4961" onColor="#28D094" />
                  </div>
                )}
                {this.state.ericConfig.activo && this.state.ericCapacidadesTenant.ocr_patente && (
                  <div className="d-flex align-items-center">
                    <label className="label-control mb-0 mr-2"><FormattedMessage id="tipoFormularioAbm.eric.ocr_patente_label" defaultMessage="OCR Patente" />:</label>
                    <Switch onChange={valor => this.handleEricToggle('ocrPatente', valor)} checked={this.state.ericConfig.ocrPatente} disabled={this.state.props.action === 'VIEW' || !Security.hasPermission('ERIC_INSPECTOR_CONFIGURAR') || this.state.ericConfig.video360 || this.state.ericConfig.brandCompliance || this.state.ericConfig.photo360} offColor="#FF4961" onColor="#28D094" />
                  </div>
                )}
                {this.state.ericConfig.activo && this.state.ericCapacidadesTenant.brand_compliance && (
                  <div className="d-flex align-items-center">
                    <label className="label-control mb-0 mr-2"><FormattedMessage id="tipoFormularioAbm.eric.brand_compliance_label" defaultMessage="Brand Compliance" />:</label>
                    <Switch onChange={valor => this.handleEricToggle('brandCompliance', valor)} checked={this.state.ericConfig.brandCompliance} disabled={this.state.props.action === 'VIEW' || !Security.hasPermission('ERIC_INSPECTOR_CONFIGURAR') || this.state.ericConfig.video360 || this.state.ericConfig.ocrOdometro || this.state.ericConfig.ocrVin || this.state.ericConfig.ocrPatente || this.state.ericConfig.photo360} offColor="#FF4961" onColor="#28D094" />
                  </div>
                )}
                {this.state.ericConfig.activo && this.state.ericCapacidadesTenant.photo_360 && (
                  <div className="d-flex align-items-center">
                    <label className="label-control mb-0 mr-2"><FormattedMessage id="tipoFormularioAbm.eric.photo_360_label" defaultMessage="Photo 360°" />:</label>
                    <Switch onChange={valor => this.handleEricToggle('photo360', valor)} checked={this.state.ericConfig.photo360} disabled={this.state.props.action === 'VIEW' || !Security.hasPermission('ERIC_INSPECTOR_CONFIGURAR') || this.state.ericConfig.video360 || this.state.ericConfig.ocrOdometro || this.state.ericConfig.ocrVin || this.state.ericConfig.ocrPatente || this.state.ericConfig.brandCompliance} offColor="#FF4961" onColor="#28D094" />
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </React.Fragment>
    );
  }

  // VEC-3955: props del proveedor común para cada pregunta (solo las que generan ticket correctivo las usan).
  propsProveedorComun(atributo, info) {
    if (!info || !this.esPreguntaCorrectiva(atributo)) return {};
    return {
      proveedorComun: info.proveedorId,
      proveedorEditable: info.definidaPor === atributo,
      preguntaProveedor: info.definidaPor.nombre,
      serviciosCorrectivos: info.servicios,
    };
  }

  render() {
    let state = this.state;
    this.formValidation.validate();
    let formData = this.state.formData;
    const proveedorComunInfo = this.getProveedorComunInfo();
    let validationState = this.formValidation.state;
    let ericHabilitado = ConfigBusiness.get('eric.inspecciones.general.activo') === 'true';

    return (
      <React.Fragment>
        {this.state.redirectTo && <Redirect push to={this.state.redirectTo} />}
        {this.state.loading && <Loading />}
        <div className="row">
          <div className="col-md-12">
            <div className="alert alert-danger" role="alert" hidden={this.state.errors.length === 0}>
              {this.state.errors.map((e, i) => (
                <li key={i}>
                  <FormattedMessage {...(backendStrings[e] ? backendStrings[e] : backendStrings["errors.default"])} />
                </li>
              ))}
            </div>
            <form className="form form-horizontal" ref="form" onSubmit={this.handleSubmit}>
              <div className="form-body">
                <div className="card pull-up">
                  <div className="card-content">
                    <div className="card-body">
                      <h4 className="form-section">
                        <i className="icon-home"></i>
                        <FormattedMessage
                          id="tipoFormularioAbm.render.general_data.header_datos_generales"
                          defaultMessage=" Datos Generales "
                        />
                        <div className="float-right" style={{ fontSize: "14px" }}>
                          <FormattedMessage
                            id="tipoFormularioAbm.render.general_data.campos_requeridos"
                            defaultMessage="* campos requeridos"
                          />
                        </div>
                      </h4>

                      <div className="row form-group">
                        {/* Icono */}
                        <div className="col-md-6">
                          <div className="row">
                            <label className="col-md-3 label-control col-form-label" htmlFor="icono">
                              <FormattedMessage
                                id="tipoFormularioAbm.render.general_data.label_tipo"
                                defaultMessage="Tipo *:"
                              />
                            </label>
                          </div>
                        </div>
                        <div className="col-md-9">
                          <div className="row" style={{ height: "20px" }}>
                            <div className="offset-md-2 col-md-10" style={{ bottom: "40px" }}>
                              {this.props.action === "VIEW" && <i className={formData.icono + " fa-2x"} />}
                              {this.props.action !== "VIEW" &&
                                ICONS.map((icono, index) => (
                                  <button
                                    disabled={this.props.action === "VIEW"}
                                    className={
                                      formData.icono === icono
                                        ? icono + " btn btn-primary fa-2x bt-icon-select"
                                        : icono + " btn btn-default fa-2x bt-icon-select"
                                    }
                                    key={icono}
                                    onClick={(e) => this.handleIconChange(e, icono)}
                                  ></button>
                                ))}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        {/* Nombre */}
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-md-3 label-control col-form-label" htmlFor="nombre">
                              <FormattedMessage
                                id="tipoFormularioAbm.render.general_data.label_nombre"
                                defaultMessage="Nombre *:"
                              />
                            </label>
                            <div className="col-md-9">
                              <input
                                disabled={this.props.action === "VIEW"}
                                type="text"
                                className="form-control"
                                id="nombre"
                                name="nombre"
                                placeholder={this.props.intl.formatMessage({
                                  id: "tipoFormularioAbm.render.general_data.placeholder_nombre",
                                  defaultMessage: "Modelo",
                                })}
                                value={formData.nombre}
                                onChange={this.handleInputFormChange}
                              />
                              <div
                                className="help-block text-danger field-message"
                                hidden={
                                  validationState.formData.nombre.pristine || validationState.formData.nombre.valid
                                }
                              >
                                {validationState.formData.nombre.message}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        {/* Descripción */}
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-md-3 label-control col-form-label" htmlFor="descripcion">
                              <FormattedMessage
                                id="tipoFormularioAbm.render.general_data.label_descripcion"
                                defaultMessage="Descripción:"
                              />
                            </label>
                            <div className="col-md-9">
                              <textarea
                                disabled={this.props.action === "VIEW"}
                                className="form-control"
                                id="descripcion"
                                name="descripcion"
                                value={formData.descripcion}
                                onChange={this.handleInputFormChange}
                              ></textarea>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group row">
                            {/* Vehículo */}
                            <label className="col-md-3 label-control col-form-label" htmlFor="activo">
                              <FormattedMessage
                                id="tipoFormularioAbm.render.general_data.label_movil"
                                defaultMessage="Móvil:"
                              />
                            </label>
                            <div className="col-md-3 mt-auto">
                              <Switch
                                onChange={value => {
																		this.handleCheckboxChange("con_movil", value)
																		this.handleCheckboxChange("con_persona", !value)
																		if (!value) {
																			this.handleConMedidorChange(false)
																		}else{
																			this.handleCheckboxChange("con_ticket", false)
																		}
																	}
																}
                                checked={formData.con_movil}
                                options={this.state.estados}
                                valueKey="id"
                                labelKey="nombre"
                                disabled={this.state.props.action === "VIEW" ? true : false}
                                offColor="#FF4961"
                                onColor="#28D094"
                              />
                            </div>

                            {/* Persona */}
														<label className="col-md-3 label-control col-form-label" htmlFor="activo">
															<FormattedMessage id="tipoFormularioAbm.render.general_data.label_persona" defaultMessage="Persona:"/>
														</label>
														<div className="col-md-3 mt-auto">
															<Switch
																onChange={value => {
																		this.handleCheckboxChange("con_persona", value)
																		this.handleCheckboxChange("con_movil", !value)
																		this.handleCheckboxChange("con_chofer", !value)
																		if (value) {
																			this.handleCheckboxChange("con_ticket", false)
																			this.handleConMedidorChange(false)
																			this.handleCheckboxChange('con_chofer', false)
																		}
																	}
																}
																checked={formData.con_persona}
																options={this.state.estados}
																valueKey='id'
																labelKey='nombre'
																disabled={this.state.props.action === 'VIEW' ? true: false }
																offColor="#FF4961"
																onColor="#28D094"
															/>
														</div>
                          </div>
                        </div>
												<div className="col-md-6">
													<div className="form-group row">
														{/* Ticket */}
														<label className="col-md-3 label-control col-form-label" htmlFor="activo">
															<FormattedMessage id="Ticket" defaultMessage="Ticket"/>:
														</label>
														<div className="col-md-3 mt-auto">
															<Switch
																onChange={value => {
																		this.handleCheckboxChange("con_ticket", value ? true: false)
																		this.handleCheckboxChange("con_persona", value ? false: false)
																		this.handleCheckboxChange("con_movil", value ? false: true)
																		this.handleCheckboxChange("con_chofer", !value)
																		this.handleConMedidorChange(false)
																	}
																}
																checked={formData.con_ticket}
																options={this.state.estados}
																valueKey='id'
																labelKey='nombre'
																disabled={this.state.props.action === 'VIEW' ? true: false }
																offColor="#FF4961"
																onColor="#28D094"
															/>
														</div>
													</div>
												</div>
											</div>
											{formData.con_movil ? (
                      <>
                        <div className="row">
                          <div className="col-md-6">
                            <div className="form-group row">
                              <label className="col-md-3 label-control col-form-label" htmlFor="activo">
                                <FormattedMessage id="tipoFormularioAbm.render.general_data.label_actualiza_medidor" defaultMessage="Actualiza Medidor:"/>
                              </label>
                              <div className="col-md-3 mt-auto">
                                <Switch
                                  onChange={value => this.handleConMedidorChange(value)}
                                  checked={formData.con_medidor}
                                  options={this.state.estados}
                                  valueKey='id'
                                  labelKey='nombre'
                                  disabled={this.state.props.action === 'VIEW'}
                                  offColor="#FF4961"
                                  onColor="#28D094"
                                />
                              </div>
                              <label className="col-md-3 label-control col-form-label" htmlFor="activo">
                                <FormattedMessage id="formularioAbm.actualizar_chofer" defaultMessage="Actualizar Chofer" />:
                              </label>
                              <div className="col-md-3 mt-auto">
                                <Switch
                                  onChange={value => this.handleCheckboxChange('con_chofer', value)}
                                  checked={formData.con_chofer}
                                  options={this.state.estados}
                                  valueKey='id'
                                  labelKey='nombre'
                                  disabled={this.state.props.action === 'VIEW'}
                                  offColor="#FF4961"
                                  onColor="#28D094"
                                />
                              </div>
                            </div>
                          </div>
                          {ConfigBusiness.get('checklist.permiteAutogestion.habilitado') === 'true' &&
                          <div className="col-md-6">
                            <div className="form-group row">
                              <label className="col-md-3 label-control col-form-label" htmlFor="activo">
                                <FormattedMessage id="tipoFormularioAbm.render.general_data.label_autogestion" defaultMessage="Genera Tickets en Autogestión?:" />
                              </label>
                              <div className="col-md-3 mt-auto">
                                <Switch
                                  onChange={value => this.handleCheckboxChange('autogestion', value)}
                                  checked={formData.autogestion}
                                  valueKey='id'
                                  labelKey='nombre'
                                  disabled={this.state.props.action === 'VIEW'}
                                  offColor="#FF4961"
                                  onColor="#28D094"
                                />
                              </div>
                            </div>
                          </div>}
                          <div className="col-md-6">
                            <div className="form-group row">
                              {/* Validacion ejecucion en App solamente */}
                              <label className="col-md-3 label-control col-form-label" htmlFor="activo">
                                <FormattedMessage id="tipoFormularioAbm.exclusivoApp" defaultMessage="Exclusivo App"/>:
                              </label>
                              <div className="col-md-3 mt-auto">
                                <Switch
                                  onChange={value => {
                                      this.handleCheckboxChange("exclusivoApp", value ? true: false)
                                    }
                                  }
                                  checked={formData.exclusivoApp}
                                  options={this.state.estados}
                                  valueKey='id'
                                  labelKey='nombre'
                                  disabled={this.state.props.action === 'VIEW' ? true: false }
                                  offColor="#FF4961"
                                  onColor="#28D094"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-6">
                            <div className="form-group row">
                              {ConfigBusiness.get('checklist.transportadora.actualizarTransportadora') === 'true' && (
                                <>
                                  <label className="col-md-3 label-control col-form-label" htmlFor="con_transportadora">
                                    <FormattedMessage id="tipoFormularioAbm.render.general_data.label_actualiza_transportadora" defaultMessage="Actualizar Transportadora"/>:
                                  </label>
                                  <div className="col-md-3 mt-auto">
                                    <Switch
                                      onChange={value => this.handleCheckboxChange('con_transportadora', value)}
                                      checked={formData.con_transportadora}
                                      options={this.state.estados}
                                      valueKey='id'
                                      labelKey='nombre'
                                      disabled={this.state.props.action === 'VIEW'}
                                      offColor="#FF4961"
                                      onColor="#28D094"
                                    />
                                  </div>
                                </>
                              )}
                              {ConfigBusiness.get('moviles.vinculacionActivos.habilitado') === 'true' && (
                                <>
                                  <label className="col-md-3 label-control col-form-label" htmlFor="con_activo_vinculado">
                                    <FormattedMessage id="tipoFormularioAbm.render.general_data.label_actualiza_activo_vinculado" defaultMessage="Actualizar Activo Vinculado"/>:
                                  </label>
                                  <div className="col-md-3 mt-auto">
                                    <Switch
                                      onChange={value => this.handleCheckboxChange('con_activo_vinculado', value)}
                                      checked={formData.con_activo_vinculado}
                                      options={this.state.estados}
                                      valueKey='id'
                                      labelKey='nombre'
                                      disabled={this.state.props.action === 'VIEW'}
                                      offColor="#FF4961"
                                      onColor="#28D094"
                                    />
                                  </div>
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-6">
                            <div className="form-group row">
                              <label className="col-md-3 label-control col-form-label">
                                <FormattedMessage id="tipoFormularioAbm.render.general_data.label_busqueda_por" defaultMessage="Búsqueda por:" />
                              </label>
                              <div className="col-md-9">
                                <Select
                                  name="buscar_movil_por"
                                  value={formData.buscar_movil_por || 'dominio'}
                                  options={this.state.buscarMovilPorOptions}
                                  onChange={option => this.handleCheckboxChange('buscar_movil_por', option ? option.value : 'dominio')}
                                  clearable={false}
                                  searchable={false}
                                  disabled={this.state.props.action === 'VIEW'}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                       ) : (
                      <>
                        <div className="row">
                          <div className="col-md-6">
                            <div className="form-group row">
                              {/* Validacion ejecucion en App solamente */}
                              <label className="col-md-3 label-control col-form-label" htmlFor="activo">
                                <FormattedMessage id="tipoFormularioAbm.exclusivoApp" defaultMessage="Exclusivo App"/>:
                              </label>
                              <div className="col-md-3 mt-auto">
                                <Switch
                                      onChange={value => {
                                        this.handleCheckboxChange("exclusivoApp", value ? true: false)
                                      }
                                    }
                                  checked={formData.exclusivoApp}
                                  options={this.state.estados}
                                  valueKey='id'
                                  labelKey='nombre'
                                  disabled={this.state.props.action === 'VIEW' ? true: false }
                                  offColor="#FF4961"
                                  onColor="#28D094"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        {formData.con_persona && ConfigBusiness.get('checklist.transportadora.actualizarTransportadora') === 'true' && ConfigBusiness.get('checklist.transportadora.actualizaTransportadora.actualizarCC') === 'true' ?
                          <div className="row">
                            <div className="col-md-6">
                              <div className="form-group row">
                                <label className="col-md-3 label-control col-form-label" htmlFor="con_transportadora">
                                  <FormattedMessage id="tipoFormularioAbm.render.general_data.label_actualiza_centro_costo" defaultMessage="Actualizar Centro de Costo"/>:
                                </label>
                                <div className="col-md-3 mt-auto">
                                  <Switch
                                    onChange={value => this.handleCheckboxChange('con_transportadora', value)}
                                    checked={formData.con_transportadora}
                                    options={this.state.estados}
                                    valueKey='id'
                                    labelKey='nombre'
                                    disabled={this.state.props.action === 'VIEW'}
                                    offColor="#FF4961"
                                    onColor="#28D094"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        : ''}
                      </>
                       )}
                      <div className="row">
                        {/* Perfil */}
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-md-3 label-control col-form-label" htmlFor="descripcion">
                              <FormattedMessage id="tipoFormularioAbm.render.general_data.label_perfil_notificar" defaultMessage="Perfil a Notificar:" />
                            </label>
                            <div className="col-md-9">
                              <Select
                                placeholder="Seleccione"
                                options={this.state.perfilesSelect}
                                valueKey="id"
                                labelKey="nombre"
                                multi
                                value={formData.perfiles}
                                onChange={(e) => this.handlePerfilChange(e)}
                                disabled={this.state.props.action === "VIEW"}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        {/*Perfil Notificar Activar*/}
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-md-3 label-control col-form-label" htmlFor="perfil_notificar_activo">
                              <FormattedMessage
                                id="tipoFormularioAbm.render.general_data.label_perfil_responder_activo"
                                defaultMessage="Perfil a Responder:"
                              />
                            </label>
                            <div className="col-md-9 mt-auto">
                              <Switch
                                onChange={(value) => this.handleCheckboxChange("perfil_notificar_activo", value)}
                                checked={formData.perfil_notificar_activo}
                                options={this.state.estados}
                                id="perfil_notificar_activo"
                                name="perfil_notificar_activo"
                                valueKey="id"
                                labelKey="nombre"
                                disabled={this.state.props.action === "VIEW" ? true : false}
                                offColor="#FF4961"
                                onColor="#28D094"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      {formData.perfil_notificar_activo ?
                      <div className="row">
                        {/* Perfil Notificar*/}
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-md-3 label-control col-form-label" htmlFor="perfiles_responder">
                              <FormattedMessage id="tipoFormularioAbm.render.general_data.label_perfiles_responder" defaultMessage="Perfil a Responder:"/>
                            </label>
                            <div className="col-md-9">
                              <Select
                                placeholder="Seleccione"
                                options={this.state.perfilesSelect}
                                valueKey="id"
                                labelKey="nombre"
                                multi
                                value={formData.perfiles_responder}
                                onChange={(e) => this.handlePerfilResponderChange(e)}
                                disabled={this.state.props.action === "VIEW"}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      : ''}
                      {formData.con_movil ?
                        <div className="row">
                          {/* Atributos de Movil*/}
                          <div className="col-md-6">
                            <div className="form-group row">
                              <label className="col-md-3 label-control col-form-label" htmlFor="perfiles_responder">
                                <FormattedMessage id="tipoFormularioAbm.render.general_data.label_atributo_de_vehiculo" defaultMessage="Atributo de Vehículo:"/>
                              </label>
                              <div className="col-md-9">
                                <Select
                                  placeholder="Seleccione"
                                  options={this.state.movil_atributos}
                                  valueKey="id"
                                  labelKey="nombre"
                                  multi
                                  value={formData.movil_atributos}
                                  onChange={(e) => this.handleAtributo(e, "movil_atributos")}
                                  disabled={this.state.props.action === "VIEW"}
                                />
                              </div>
                            </div>
                          </div>
                          {ConfigBusiness.get('checklist.respuesta.estadomoviles') === 'true' ?
                            <div className="col-md-6">
                              <div className="form-group row">
                                <label className="col-md-4 label-control col-form-label" htmlFor="movil_estados_disponibles">
                                  <i className="icon-info"
                                    title={this.props.intl.formatMessage({
                                      id: "tipoFormularioAbm.select_movil_estados_info.si_no_se_seleciona_ningun_estado_solo_se_tendra_en_cuenta_los_activos",
                                      defaultMessage: "Si no se selecciona ningún estado, solo se tendrán en cuenta los Activos",
                                    })}
                                    style={{color: "#00c0bd", fontSize: "15px", paddingRight: "5px"}}
                                  ></i>
                                  <FormattedMessage id="TipoFormularioAbm.render.general_data.label_estados_disponibles" defaultMessage="Estados Disponibles"/>:
                                </label>
                                <div className="col-md-8">
                                  <Select
                                    placeholder="Seleccione"
                                    options={this.state.movil_estados}
                                    valueKey="id"
                                    labelKey="nombre"
                                    multi
                                    value={formData.movil_estados_disponibles}
                                    onChange={(e) => this.handleAtributo(e, "movil_estados_disponibles")}
                                    disabled={this.state.props.action === "VIEW"}
                                  />
                                </div>
                              </div>
                            </div>
                          : ''}
                        </div>
                      : ''}
                      {formData.con_persona && ConfigBusiness.get('checklist.respuesta.estadopersonas') === 'true' ?
                        <div className="row">
                          <div className="col-md-6">
                            <div className="form-group row">
                              <label className="col-md-3 label-control col-form-label" htmlFor="persona_estados_disponibles">
                                <i className="icon-info"
                                  title={this.props.intl.formatMessage({
                                    id: "tipoFormularioAbm.select_persona_estados_info.si_no_se_seleciona_ningun_estado_solo_se_tendra_en_cuenta_los_activos",
                                    defaultMessage: "Si no se selecciona ningún estado, solo se tendrán en cuenta las personas Activas",
                                  })}
                                  style={{color: "#00c0bd", fontSize: "15px", paddingRight: "5px"}}
                                ></i>
                                <FormattedMessage id="TipoFormularioAbm.render.general_data.label_persona_estados_disponibles" defaultMessage="Estados Disponibles"/>:
                              </label>
                              <div className="col-md-9">
                                <Select
                                  placeholder="Seleccione"
                                  options={this.state.persona_estados}
                                  valueKey="id"
                                  labelKey="nombre"
                                  multi
                                  value={formData.persona_estados_disponibles}
                                  onChange={(e) => this.handleAtributo(e, "persona_estados_disponibles")}
                                  disabled={this.state.props.action === "VIEW"}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      : ''}
                      {formData.con_ticket ?
                        <div className="row">
                          {/* Atributos de ticket */}
                          <div className="col-md-6">
                            <div className="form-group row">
                              <label className="col-md-3 label-control col-form-label" htmlFor="atributos_de_tickets">
                                <FormattedMessage id="atributos_de_tickets" defaultMessage="Atributos de tickets"/>:
                              </label>
                              <div className="col-md-9">
                                <Select
                                  placeholder="Seleccione"
                                  options={this.state.ticket_atributos}
                                  valueKey="id"
                                  labelKey="nombre"
                                  multi
                                  value={formData.ticket_atributos}
                                  onChange={(e) => this.handleAtributo(e, "ticket_atributos")}
                                  disabled={this.state.props.action === "VIEW"}
                                  isOptionDisabled={(option) => option.isDisabled}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      : ''}
                      {formData.con_ticket ?
                        <div className="row">
                          <div className="col-md-6">
                            <div className="form-group row">
                              <label className="col-md-3 label-control col-form-label" htmlFor="ticket_estados">
                                <FormattedMessage id="tipoFormularioAbm.render.label_ticket_estados" defaultMessage="Estados"/>:
                              </label>
                              <div className="col-md-9">
                                <Select
                                  placeholder="Seleccione"
                                  options={this.state.ticket_estados_disponibles}
                                  valueKey="id"
                                  labelKey="nombre"
                                  multi
                                  value={formData.ticket_estados}
                                  onChange={(e) => this.handleAtributo(e, "ticket_estados")}
                                  disabled={this.state.props.action === "VIEW"}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      : ''}
                      <div className="row">
                        {/* ESTADO */}
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-md-3 label-control col-form-label" htmlFor="activo">
                              <FormattedMessage
                                id="tipoFormularioAbm.render.general_data.label_activo"
                                defaultMessage="Activo:"
                              />
                            </label>
                            <div className="col-md-9 mt-auto">
                              <Switch
                                onChange={(value) => this.handleCheckboxChange("activo", value)}
                                checked={formData.activo}
                                options={this.state.estados}
                                id="activo"
                                name="activo"
                                valueKey="id"
                                labelKey="nombre"
                                disabled={this.state.props.action === "VIEW" ? true : false}
                                offColor="#FF4961"
                                onColor="#28D094"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Static Eric IA card when disabled — pinned above the DnD list */}
                {!this.state.ericConfig.activo && ConfigBusiness.get('eric.inspecciones.general.activo') === 'true' && (
                  <div className={"card pull-up eric-rainbow" + (this.state.ericAnimating === 'off-entering' ? ' eric-enter-top' : this.state.ericAnimating === 'on-exiting' ? ' eric-exit-top' : '')}>
                    <div className="card-content">
                      <div className="card-body">
                        {this.renderEricIACardInner()}
                      </div>
                    </div>
                  </div>
                )}

                {!this.state.loading && (
                  <DragDropContext onDragEnd={this.onDragEnd}>
                    <Droppable droppableId={"1"}>
                      {(provided, snapshot) => (
                        <div
                          ref={provided.innerRef}
                          {...provided.droppableProps}
                          style={snapshot.isDraggingOver ? { background: "lightblue" } : {}}
                        >
                          {construirListaVisibleAtributos(this.state.formData.atributos_dinamicos, this.state.ericConfig.activo)
                            .map(
                            ({ atributoDinamico, indiceReal }, index) =>
                              atributoDinamico &&
                              (atributoDinamico.activo || this.state.mostrarInactivos) && (
                                atributoDinamico.tipoValor === Constants.ID_ERIC_IA ? (
                                  <Draggable
                                    key="eric-ia"
                                    draggableId="eric-ia"
                                    index={index}
                                    isDragDisabled={this.state.props.action === 'VIEW'}
                                  >
                                    {(ericProvided, ericSnapshot) => (
                                      <div
                                        ref={function(el) { ericProvided.innerRef(el); this._ericCardRef = el; }.bind(this)}
                                        {...ericProvided.draggableProps}
                                        {...(this.state.props.action !== 'VIEW' ? ericProvided.dragHandleProps : {})}
                                        className={"card pull-up" + (this.state.ericAnimating === 'off-exiting' ? ' eric-exit-up' : this.state.ericAnimating === 'on-entering' ? ' eric-enter-list' : '') + (!ericSnapshot.isDragging ? ' eric-rainbow' : '')}
                                        onMouseEnter={() => this.setState({ ericHovered: true })}
                                        onMouseLeave={() => this.setState({ ericHovered: false })}
                                      >
                                        <div className="card-content">
                                          <div className="card-body">
                                            {this.state.props.action !== 'VIEW' && this.state.ericHovered && (
                                              <span className="pull-right">
                                                <i className="grey-color fa fa-bars"></i>
                                              </span>
                                            )}
                                            {this.renderEricIACardInner()}
                                          </div>
                                        </div>
                                      </div>
                                    )}
                                  </Draggable>
                                ) : (
                                  <AtributoDinamico
                                    mostrarInactivos={this.state.mostrarInactivos}
                                    handleDelete={() => this.handleDeleteAtributoDinamico(indiceReal)}
                                    index={index}
                                    key={this.getAtributoDragKey(atributoDinamico)}
                                    dragId={this.getAtributoDragKey(atributoDinamico)}
                                    previsualizacion={true}
                                    modulo={"checklist"}
                                    disabled={this.state.props.action === "VIEW"}
                                    draggable={this.state.props.action !== "VIEW"}
                                    handleChange={(_, key, value) => this.handleChangeAtributoDinamico(indiceReal, key, value)}
                                    formulario={atributoDinamico}
                                    tipoPersona={this.state.formData.con_persona}
                                    tipoTicket={this.state.formData.con_ticket}
                                    movil_estados={this.state.movil_estados}
                                    tipoFormularioId={this.state.formData.id}
                                    {...this.propsProveedorComun(atributoDinamico, proveedorComunInfo)}
                                  />
                                )
                              )
                          )}
                          {provided.placeholder}
                        </div>
                      )}
                    </Droppable>
                  </DragDropContext>
                )}
                <div className="card pull-up">
                  <div className="card-content">
                    <div className="card-body">
                      <div className="text-cd text-right">
                        {this.props.action !== "VIEW" && (
                          <>
                            <button
                              type="button"
                              className="btn btn-success pull-left mr-1"
                              onClick={this.handleAddAtributoDinamico}
                            >
                              <i className="fa fa-plus"></i>
                              <FormattedMessage
                                id="tipoFormularioAbm.render.add_attribute_button.agregar_atributo_dinamico"
                                defaultMessage=" Agregar Atributo Dinámico"
                              />
                            </button>
                            <button
                              type="submit"
                              className="btn btn-primary mr-1"
                              disabled={!validationState.form.valid || this.atributoDinamicoServicosRequeridosFaltantes() || this.atributoDinamicoFormularioAsociadoFaltante()}
                            >
                              <i className="fa fa-check-circle"></i>
                              <FormattedMessage
                                id="tipoFormularioAbm.render.finish_button.guardar"
                                defaultMessage=" Guardar"
                              />
                            </button>
                          </>
                        )}
                        <button type="button" className="btn btn-danger" onClick={this.handleCancel.bind(this)}>
                          <i className="fa fa-times-circle"></i>{" "}
                          {this.props.action === "VIEW"
                            ? this.props.intl.formatMessage({
                                id: "tipoFormularioAbm.render.finish_button.volver",
                                defaultMessage: "Volver",
                              })
                            : this.props.intl.formatMessage({
                                id: "tipoFormularioAbm.render.finish_button.cancelar",
                                defaultMessage: "Cancelar",
                              })}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
        {/* Modal de video explicativo Eric IA */}
        {this.state.mostrarVideoEric && (
          <div
            className="modal fade show"
            style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1050 }}
            onClick={() => this.setState({ mostrarVideoEric: false })}
          >
            <div
              className="modal-dialog modal-lg"
              style={{ marginTop: '80px' }}
              onClick={function(e) { e.stopPropagation(); }}
            >
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">
                    <i className="fa fa-magic mr-1"></i>
                    Eric IA — Inspection &amp; OCR
                  </h5>
                  <button
                    type="button"
                    className="close"
                    onClick={() => this.setState({ mostrarVideoEric: false })}
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div className="modal-body">
                  <div className="embed-responsive embed-responsive-16by9">
                    <iframe
                      className="embed-responsive-item"
                      src={ConfigBusiness.get('eric.inspecciones.general.embedUrl') || ''}
                      title="Eric IA — Inspection &amp; OCR"
                      allowFullScreen
                    ></iframe>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </React.Fragment>
    );
  }
}

export default injectIntl(TipoFormularioAbm);
